export default class LoadingOverlay {
    constructor() {
        this.identifier = '[data-loading-overlay]';
        this.timeout = null;
    }

    taskStarted() {
        this.setActiveTasks(this.getActiveTasks() + 1);
        this.setTimeout();
    }

    taskFinished() {
        let numTasks = this.getActiveTasks();
        if (numTasks >= 1) {
            this.setActiveTasks(--numTasks);
        }
    }

    setTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.applyTimeout.bind(this), 10000);
    }

    applyTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.setActiveTasks(0);
        this.timeout = null;
    }

    getActiveTasks() {
        return parseInt(document.querySelector(this.identifier).dataset.activeTasks);
    }

    setActiveTasks(numTasks) {
        document.querySelector(this.identifier).dataset.activeTasks = numTasks;
    }
}
